import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AuthLayout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const redirect = encodeURIComponent(location.pathname + location.search);

  return isAuthenticated ? <Outlet /> : <Navigate to={`/login?redirect=${redirect}`} replace />;
};

export default AuthLayout;
